import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import {
  BundlesAssignmentsColumns,
  mapBundlesAssignmentsViewQuery,
} from "./BundlesAssignmentsView.default";
import { getBundlesAssignments } from "../../repository/data.repository";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import { createGridRequest } from "../../hooks/useGridRequest";
import { bundleScopedSearchSchema } from "../bundles/bundleFilters";

export interface BundlesAssigmentsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function BundlesAssignmentsView(props: BundlesAssigmentsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={BundlesAssignmentsColumns}
      mapQuery={mapBundlesAssignmentsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getBundlesAssignments, { retry: true })}
      pageSize={100}
      schema={bundleScopedSearchSchema}
      actions={(record) => [
        {
          key: "view",
          label: "View",
          disabled: !permissions.can("Bundles", "view"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit allocation",
          disabled: !permissions.can("Bundles", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Bundles", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default BundlesAssignmentsView;
